import { CommentItem } from "src/api/comment";

export enum MessageSender {
  Bot = "bot",
  User = "user",
}

export interface SourceInfo {
  page_title: string;
  section_heading: string;
  doc_type: string;
  url: string;
  page_id: string;
  chunk_id: string;
}

// Bot replies may contain inline citation markers like [sop-ca93c5]; the
// SSE stream emits a [SOURCES] frame mapping each marker to its source
// metadata. The map is merged into this field as frames arrive.
export interface Message {
  id: number;
  message: string;
  sender: MessageSender;
  isProcessing?: boolean;
  docs: string[];
  images?: string[];
  imagesLoading: boolean;
  sources?: Record<string, SourceInfo>;
}

export interface MessageDropdownState {
  messageId: number | null;
  position: { x: number; y: number } | null;
}

export interface CommentDialogState {
  isOpen: boolean;
  messageId: number | null;
  originalMessage: string;
  botResponse: string;
  comment: string;
  suggestedResponse: string | null;
  isLoading: boolean;
}

export interface EditCommentDialogState {
  isOpen: boolean;
  comments: CommentItem[];
  isLoading: boolean;
  selectedComment?: CommentItem;
  showDeleteConfirm: boolean;
  originalQuery: string;
}
